import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import AboutUsSection__structures2 from '../components/__structures/AboutUsSection__structures2';
import AboutUsSectionTeams1 from '../components/teams/AboutUsSectionTeams1';
import AboutUsSectionFooters3 from '../components/footers/AboutUsSectionFooters3';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function AboutUs() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <AboutUsSection__structures2 />
      <AboutUsSectionTeams1 />
      <AboutUsSectionFooters3 />
    </React.Fragment>
  );
}

